import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { UseOrderByReturn, WorkspaceOrderByKeys, WorkspaceOrderByState } from './types';

export const useOrderBy = (): UseOrderByReturn => {
  const history = useHistory();
  const location = useLocation();

  const searchParams = React.useMemo(() => new URLSearchParams(location.search), [location.search]);

  const orderBy: WorkspaceOrderByState = React.useMemo(() => {
    const orderKey = searchParams.get(`orderBy`);
    const descending = searchParams.get(`desc`) === `1`;
    return {
      key: (orderKey as WorkspaceOrderByKeys) || undefined,
      descending: descending,
    };
  }, [searchParams]);

  const setOrderBy = (
    newStateOrUpdater: WorkspaceOrderByState | ((prev: WorkspaceOrderByState) => WorkspaceOrderByState)
  ) => {
    const newOrderBy = typeof newStateOrUpdater === `function` ? newStateOrUpdater(orderBy) : newStateOrUpdater;
    if (newOrderBy.key) {
      searchParams.set(`orderBy`, newOrderBy.key);
    } else {
      searchParams.delete(`orderBy`);
    }
    if (newOrderBy.descending) {
      searchParams.set(`desc`, `1`);
    } else {
      searchParams.delete(`desc`);
    }
    const newSearch = searchParams.toString();
    if (newSearch !== location.search) {
      history.replace({ ...location, search: newSearch });
    }
  };

  return { orderBy, setOrderBy };
};
